(function () {
  var STORAGE_KEY = 'recently_viewed_products';
  var MAX_STORED = 20;
  var CARD_SECTION_ID = 'recently-viewed-card';

  function getStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function setStored(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function fetchCardHtml(handle) {
    return fetch('/products/' + handle + '?section_id=' + CARD_SECTION_ID)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrapper = doc.getElementById('shopify-section-' + CARD_SECTION_ID);
        return wrapper ? wrapper.innerHTML.trim() : '';
      })
      .catch(function () {
        return '';
      });
  }

  function waitForSwiper(attempts, fn) {
    if (typeof window.Swiper === 'function') {
      fn();
    } else if (attempts > 0) {
      setTimeout(function () {
        waitForSwiper(attempts - 1, fn);
      }, 100);
    }
  }

  function initCard(li) {
    // Embedded <script>/<style> tags from the fetched card fragment never run
    // when inserted via innerHTML, so re-apply what they would have done.

    li.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });

    li.querySelectorAll('.color-swatch').forEach(function (el) {
      // Matches ".collection .color-swatch" sizing, which only applies inside
      // a real collection grid and doesn't reach this dynamically-inserted card.
      el.style.display = 'inline-block';
      el.style.width = '24px';
      el.style.height = '24px';
      el.style.borderRadius = '50%';
      el.style.margin = '3px';
      el.style.border = '1px solid #000';
    });

    li.querySelectorAll('.size-select').forEach(function (el) {
      // Matches ".product-grid .option-sizes select" sizing, same reasoning.
      el.style.width = '70px';
      el.style.color = '#000';
    });

    var swiperContainer = li.querySelector('.swiper-container[id^="swiper-"]');
    if (swiperContainer) {
      waitForSwiper(50, function () {
        var productId = swiperContainer.id.replace('swiper-', '');
        var paginationEl = li.querySelector('#swiper-pagination-' + productId);
        window._cardSwipers = window._cardSwipers || {};
        window._cardSwipers[productId] = new window.Swiper(swiperContainer, {
          pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined,
          slidesPerView: 1,
          spaceBetween: 10,
          simulateTouch: true,
          preventClicks: true,
          preventClicksPropagation: true
        });
      });
    }
  }

  function wireNav(container, listEl) {
    var prev = container.querySelector('[data-recently-viewed-prev]');
    var next = container.querySelector('[data-recently-viewed-next]');
    if (!prev || !next) return;

    function scrollByCard(dir) {
      var card = listEl.querySelector('.grid__item');
      var gap = parseInt(window.getComputedStyle(listEl).columnGap, 10) || 16;
      var amount = card ? card.getBoundingClientRect().width + gap : 240;
      listEl.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    function updateDisabled() {
      prev.disabled = listEl.scrollLeft <= 0;
      next.disabled = listEl.scrollLeft + listEl.clientWidth >= listEl.scrollWidth - 1;
    }

    prev.addEventListener('click', function () {
      scrollByCard(-1);
    });
    next.addEventListener('click', function () {
      scrollByCard(1);
    });
    listEl.addEventListener('scroll', updateDisabled);
    updateDisabled();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var currentScript = document.querySelector('[data-recently-viewed-current]');
    var current = null;

    if (currentScript) {
      try {
        current = JSON.parse(currentScript.textContent);
      } catch (e) {
        current = null;
      }
    }

    var stored = getStored();

    if (current && current.id) {
      stored = stored.filter(function (p) {
        return String(p.id) !== String(current.id);
      });
      stored.unshift(current);
      if (stored.length > MAX_STORED) stored = stored.slice(0, MAX_STORED);
      setStored(stored);
    }

    document.querySelectorAll('[data-recently-viewed]').forEach(function (container) {
      var listEl = container.querySelector('[data-recently-viewed-list]');
      if (!listEl) return;

      var max = parseInt(container.getAttribute('data-max'), 10) || 4;
      var currentId = current ? current.id : null;

      var items = stored
        .filter(function (p) {
          return String(p.id) !== String(currentId);
        })
        .slice(0, max);

      if (!items.length) return;

      Promise.all(
        items.map(function (product) {
          return fetchCardHtml(product.handle);
        })
      ).then(function (cardsHtml) {
        var hasAny = false;
        cardsHtml.forEach(function (cardHtml) {
          if (!cardHtml) return;
          var li = document.createElement('li');
          li.className = 'grid__item';
          li.innerHTML = cardHtml;
          listEl.appendChild(li);
          initCard(li);
          hasAny = true;
        });
        if (hasAny) {
          container.classList.add('is-visible');
          wireNav(container, listEl);
        }
      });
    });
  });
})();

